import { createContext, Dispatch, SetStateAction } from 'react';
import { LocationState } from 'src/types/LocationState.ts';

export type LocationStateContextType = {
    locationState: LocationState;
    setLocationState: Dispatch<SetStateAction<LocationState>>;
}

export const initLocationState: LocationState = {
    valveLabel: '-',
    actuatorLabel: '-',
    valvesPage: '1',
    selectedAccessories: [],
    actuatorsPage: '1',
};

export const LocationStateContext = createContext<LocationStateContextType>({
    locationState: { ...initLocationState },
    setLocationState: () => null,
});
